import {
  Button,
  Input,
  HStack,
  VStack,
  Box,
  Text,
  useToast
} from '@chakra-ui/react';
import { FaTruckMoving } from "react-icons/fa";
import { useForm } from 'react-hook-form';
import { BoxTitle } from '@/components/BoxTitle';
import { ModalAlert } from '@/components/ModalStyled/Modal';

interface TipoJanelaFormData {
  TipoJanela: string;
  descricao: string;
  observacao: string;
}

interface ModalTipoJanelaProps {
  isOpen: boolean;
  onClose: () => void;
  handleAddTipoJanela: (formData: TipoJanelaFormData) => void;
}

const ModalTipoJanela: React.FC<ModalTipoJanelaProps> = ({ isOpen, onClose, handleAddTipoJanela }) => {
  const toast = useToast();
  const {
    handleSubmit,
    setValue,
    watch,
    reset
  } = useForm<TipoJanelaFormData>({
    defaultValues: {
      TipoJanela: '',
      descricao: '',
      observacao: ''
    }
  });

  const onSubmit = async (data: TipoJanelaFormData) => {
    const missingFields = [];

    if (!data.TipoJanela) missingFields.push("TipoJanela");
    if (!data.descricao) missingFields.push("Descrição");
    if (!data.observacao) missingFields.push("Observação");

    if (missingFields.length > 0) {
      toast({
        title: missingFields.length === 1
          ? `O campo ${missingFields[0]} é obrigatório.`
          : "Faltam campos obrigatórios a serem preenchidos.",
        status: "error",
        isClosable: true,
      });
      return;
    }

    handleAddTipoJanela(data);
    toast({
      title: "TipoJanela adicionada com sucesso!",
      status: "success",
      isClosable: true,
    });
    reset();
    onClose();
  };

  return (
    <>
      <ModalAlert
        isOpen={isOpen}
        onClose={onClose}
        size='3xl'
        title={<Text fontSize={'xl'} ml={2}>Tipo de Janela</Text>}
        body={
          <Box as="form" onSubmit={handleSubmit(onSubmit)}>
            <VStack spacing={4} align="stretch">
              <HStack>
                <BoxTitle title="TipoJanela">
                  <Input value={watch("TipoJanela")} onChange={(e) => setValue("TipoJanela", e.target.value)} placeholder="Adicione uma Janela" />
                </BoxTitle>
                <BoxTitle title="Descrição">
                  <Input value={watch("descricao")} onChange={(e) => setValue("descricao", e.target.value)} placeholder="Adicione uma descrição" />
                </BoxTitle>
              </HStack>
              <BoxTitle title="Observação">
                <Input value={watch("observacao")} onChange={(e) => setValue("observacao", e.target.value)} placeholder="Insira uma observação" />
              </BoxTitle>
            </VStack>
          </Box>
        }
        footer={
          <Button colorScheme="blue" onClick={handleSubmit(onSubmit)}>
            Confirmar
          </Button>
        }
      />
    </>
  );
};

export default ModalTipoJanela;
